import axios from "axios";
import axiosCall from "../axiosCall";
import { CASE_AUTH, CASE_OAUTH_TOKEN_URL, PARTNER_AUTH, SF_CASE_BASE_AZURE_URL } from "../../constant/Constants";
import { encrypt } from "../cryptoService";

export const fetchCMoAuthDetails = async () => {

    const data = {
        grant_type: "password",
        username: "integrationuser@patientadvocate.org.cmdev",
        password: "Yuniq@1231kWvM8V55n893s9iIKVEh6url",
        client_id: "3MVG9Eroh42Z9.iWX4cMOsIVhCluy9jBzLHliZX7kmPPVnQtDWBYlMUINZ_qAkCBWZ0W4YQXijk3hN5_qaGl7",
        client_secret: "DF1AD2CD88F1ED3D6F9D3C37FDEED4D8E29571069B0458CF31AEA92F25E0E21A"
    }

    // const response = await axios.post(`https://test.salesforce.com/services/oauth2/token`, data, {
    //     // withCredentials: true, // This enables credentials
    //     headers: {
    //         "Content-Type": "application/json"
    //     }
    // });

    const response = await axios.post(CASE_OAUTH_TOKEN_URL, {}, {
        // withCredentials: true, // This enables credentials
        headers: {
            "Content-Type": "application/json"
        }
    });

    CASE_AUTH.Authorization = `Bearer ${response.data.access_token}`

    return response.data
}

// Get Patient Case Lists
export const fetchPatientCaseLists = async ({ patientid }) => {
    const response = await axiosCall('get', `nppp_viewpatientcases?`, CASE_AUTH, `patientid=${patientid}`, null, "CM");
    return response.data
}

// Get Patient Case Lists
export const fetchCaseLists = async ({ einnumber }) => {
    const response = await axiosCall('get', `nppp_viewcases?`, CASE_AUTH, `einnumber=${einnumber}`, null, "CM");
    return response.data
}

//Generate Hash Data
export const fetchGenerateHashData = async ({ portalUserId, patienId }) => {
    const data = {
        "PortalUserID": portalUserId,
        "PatientID": patienId
    }

    const response = await axiosCall('post', '/Partner/V1/GenerateHashValue', PARTNER_AUTH, null, data, "partner_cm_pega");

    return response.data
}

// Get Reports for cases
export const fetchCaseReport = async ({ einnumber, startdate, enddate }) => {
    const response = await axiosCall('get', `nppp_viewcasesreport?`, CASE_AUTH, `einnumber=${einnumber}&startdate=${startdate} 00:00:00&enddate=${enddate} 23:59:59`, null, "CM");
    return response.data
}

//Generate Hash Data
export const caseLogOut = async (caseMgtUserID) => {
    const data = encrypt({
        "externaluserid": caseMgtUserID
    })

    const response = await axios({
        method:"post",
        url : "https://patientadvocateapim.azure-api.net/sf-nppp-qa/nppp_logout",
        headers : {
            "Authorization":CASE_AUTH.Authorization,
        },
        params: "",
        data
      });

    // const response = await axiosCall('post', 'nppp_logout', {...CASE_AUTH, ...{"Content-Type":"application/json"}}, null, data, "CM");
    // const response = await axios.post("https://patientadvocateapim.azure-api.net/sf-nppp-qa/nppp_logout", data , {
    //     // withCredentials: true, // This enables credentials
    //     headers: {
    //         "Content-Type": "application/json",
    //         "Authorization":CASE_AUTH.Authorization,
    //     }
    // });

    // return response.data
}